<div class="c-form__element">
  <label class="c-form__label" [for]="inputId">{{label}}</label>
  <p-select
    [inputId]="inputId"
    [options]="values"
    [(ngModel)]="selectedValue"
    (onChange)="onChangeValue($event)"
    optionLabel="label"
    [showClear]="false">
    <ng-template #selectedItem let-selected>
      {{ selected?.label | translate }}
    </ng-template>
    <ng-template #item let-option>
      {{ option.label | translate }}
    </ng-template>
  </p-select>
</div>
